module.exports = __webpack_public_path__ + "static/media/masthead.576d2388.png";